import { useEffect, useState } from "react";

import Image from "next/image";
import { useRouter } from "next/router";

import useTranslation from "next-translate/useTranslation";
import PropTypes from "prop-types";

import SimpleUserInitialsName from "shared/components/atoms/SimpleUserInitials";
import UserProgress from "shared/components/organisms/UserProgress";
import staticIntlTranslatorToString from "shared/utils/staticIntlTranslatorToString";

import { ConfigurableUserCardContainer } from "./styles";

const ConfigurableUserCard = ({
  content,
  useProgressEnable,
  cardType,
  itemRoute,
}) => {
  const router = useRouter();
  const { lang } = useTranslation();

  const [dragging, setDragging] = useState(false);

  useEffect(() => {
    const setDragStateToFalse = () => setDragging(false);
    const setDragStateToTrue = () => setDragging(true);

    document.addEventListener("mousedown", setDragStateToFalse);
    document.addEventListener("mousemove", setDragStateToTrue);

    return () => {
      document.removeEventListener("mousedown", setDragStateToFalse);
      document.removeEventListener("mousemove", setDragStateToTrue);
    };
  }, []);

  const handleClick = () => {
    if (!dragging) {
      router.push(itemRoute + content?.username);
    }
  };

  const completeCard = cardType.includes("complete");

  const contentImg = content?.photo || content?.image;

  return (
    <ConfigurableUserCardContainer
      onClick={handleClick}
      completeCard={completeCard}
    >
      <div className="wrapper">
        {useProgressEnable ? (
          <UserProgress userSession={content} image={content.photo} />
        ) : contentImg ? (
          <div className="image-container-configurable-user-card">
            <Image
              width={120}
              height={120}
              alt="user-photo"
              className="lazy-image user-photo"
              data-src={contentImg}
              src={contentImg}
            />
          </div>
        ) : (
          <div className="image-container-configurable-user-card">
            <SimpleUserInitialsName fullName={content?.display_name} />
          </div>
        )}

        {cardType !== "image_only" && (
          <h3 className="name">
            {staticIntlTranslatorToString(content?.display_name, lang)}
          </h3>
        )}

        {completeCard && (
          <>
            <p className="bio">
              {staticIntlTranslatorToString(content?.biography, lang)}
            </p>
          </>
        )}
      </div>
    </ConfigurableUserCardContainer>
  );
};

ConfigurableUserCard.defaultProps = {
  itemRoute: "",
  useProgressEnable: false,
  cardType: "image_only",
};

ConfigurableUserCard.propTypes = {
  content: PropTypes.object.isRequired,
  useProgressEnable: PropTypes.bool,
  cardType: PropTypes.string,
  itemRoute: PropTypes.string,
};

export default ConfigurableUserCard;
